/* 🤖 this file was generated by svg-to-ts */
export const matIconCorporateFare: {
  name: 'corporate-fare';
  data: string;
} = {
  name: 'corporate-fare',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 7V3H2v18h20V7H12zm-2 12H4v-2h6v2zm0-4H4v-2h6v2zm0-4H4V9h6v2zm0-4H4V5h6v2zm10 12h-8V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z"/></svg>`
};
